import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import PlusCircleIcon from "../../assets/svg/PlusCircleIcon";
import { useSelector } from "react-redux";
import { RootState } from "@store/reducers";
import { EnumUserTypes, HiringCompanyType } from "@utils/constants";

const CalendarsPage = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const currentUserType = useSelector(
    (state: RootState) => state.auth.user.userType
  );
  const currentHiringCompanyType = useSelector(
    (state: RootState) => state.auth.user.hiringCompanyType
  );
  const { generalUnreadCount, specificUnreadCount } = useSelector(
    (state: RootState) => state.notification.meeting
  );

  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: "Meetings",
      route: "schedules",
      value: specificUnreadCount,
    },
    {
      label: "Meetings Static",
      route: "schedules1",
      value: specificUnreadCount,
    },
    {
      label: "Availability Polls",
      route: "scheduling",
      value: generalUnreadCount,
    },
    {
      label: "Calendar View",
      route: "calendar-view",
    },
  ];

  const handleCreateButton = () => {
    if (activeTab === 0) {
      navigate("/calendar/create-meeting?type=invite");
    } else {
      navigate("/calendar/create-meeting?type=meetingPoll");
    }
  };

  const canCreateMeeting =
    currentUserType !== EnumUserTypes.CANDIDATE &&
    !(
      currentUserType === EnumUserTypes.HIRING_COMPANY &&
      Number(currentHiringCompanyType) === HiringCompanyType.TEAM_MEMBER
    );

  useEffect(() => {
    tabs?.forEach((item, index) => {
      if (pathname?.includes(item?.route)) setActiveTab(index);
    });
  }, [pathname]);
  return (
    <>
      {/* Tabs wrapper */}
      <div className="flex items-center mt-4 overflow-hidden pb-1 border-b-2 border-gray-100">
        <div className="flex items-center justify-between w-full">
          {/* Tabs  container*/}
          <div className="flex items-center gap-5">
            {tabs?.map((item, index) => {
              const isSelected = activeTab === index;
              return (
                <button
                  key={item?.label}
                  onClick={() => {
                    navigate(item?.route);
                  }}
                  className={`px-3 flex justify-center items-center h-full cursor-pointer pb-1 ${
                    isSelected ? "text-primary" : "text-light-grey"
                  } font-medium text-xs gap-1`}
                >
                  <span
                    style={{
                      borderBottom: isSelected
                        ? "2px solid #2e2e2e"
                        : "2px solid transparent",
                    }}
                  >
                    {item?.label}
                  </span>
                  {item?.value ? (
                    <div className="text-xss font-medium flex items-center justify-center h-4 w-4 rounded-full bg-green-600 text-white">
                      {item?.value}
                    </div>
                  ) : null}
                </button>
              );
            })}
          </div>
          {canCreateMeeting ? (
            <button
              onClick={handleCreateButton}
              className="flex items-center rounded-md bg-primary text-white font-medium text-xs py-1 px-2 gap-1 hover:bg-black"
            >
              <PlusCircleIcon className={"w-4 h-4"} fill={"white"} />
              Create {activeTab === 0 ? "Invite" : "availability poll"}
            </button>
          ) : null}
        </div>
      </div>

      <div className="flex flex-1 mt-3 flex-grow max-h-fit overflow-y-scroll no-scrollbar">
        <Outlet />
      </div>
    </>
  );
};

export default CalendarsPage;
